import { useEffect, useState, useRef } from 'react'

export const useGetAuthorizationToken = () => {
  const accessTokenRef = useRef(null)
  const [isFetchingAccessToken, setIsFetchingAccessToken] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  useEffect(() => {
    if (accessTokenRef.current) return

    const fetchAccessToken = async () => {
      setIsFetchingAccessToken(true)
      setErrorMessage(null)

      try {
        const response = await fetch(
          'https://atm.tamedia.ch/api/ai-tools/v1/login',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              user_email: 'movie.assistant@tamedia.ch',
              password: 'vswAb0JXfLAEUmIxo1hR',
            }),
          }
        )

        const data = await response.json()
        if (response.ok) {
          accessTokenRef.current = data.access_token
        } else {
          throw new Error(data.message || 'Failed to fetch access token')
        }
      } catch (error: any) {
        setErrorMessage(error.message || 'An error occurred')
      } finally {
        setIsFetchingAccessToken(false)
      }
    }

    fetchAccessToken()
  }, [])

  return {
    accessToken: accessTokenRef.current,
    isFetchingAccessToken,
    errorMessage,
  }
}
